import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  categoryNames?: Set<string>
}
const Footer = ({ categoryNames }: Props) => {
  const hasCategories = categoryNames && categoryNames.size > 0

  return (
    <Box>
      {!hasCategories && <Text size="200">{i18n.t('clock_in.sidepanel.balance.description')}</Text>}
      {hasCategories && (
        <Text size="200">
          {i18n.t('clock_in.sidepanel.balance.description_with_time_blocks', {
            categories: Array.from(categoryNames).join(', '),
          })}
        </Text>
      )}
    </Box>
  )
}

export default Footer
